import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";



const CatalogItem = ({image, title, subtitle, desc}) => {

    return (
        <div className="catalog_item">
            <div className="catalog_image">
                <img src={image} alt="" />
            </div>
            <div className="catalog_info">
                <div className="catalog_title">
                    <h3>{title}</h3>
                    <p>{subtitle}</p>
                </div>
                <div className="catalog_desc">
                    {desc}
                </div>
            </div>
        </div>
    )
}
  
export default CatalogItem